import { IRequest } from 'src/app/models/requests';

export interface IAdvancedSOSState {
  requests: IRequest[];
  requestsDetails: IRequest[];
}
export const initIAdvancedSOSState: IAdvancedSOSState = {
  requests: [],
  requestsDetails: [],
};
